import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface DocsSidebarContextType {
  collapsed: boolean;
  toggleCollapse: () => void;
}

const DocsSidebarContext = createContext<DocsSidebarContextType | undefined>(undefined);

export function DocsSidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('docs-sidebar-collapsed') === 'true';
  });

  const toggleCollapse = useCallback(() => {
    const newState = !collapsed;
    setCollapsed(newState);
    localStorage.setItem('docs-sidebar-collapsed', String(newState));
  }, [collapsed]);

  return (
    <DocsSidebarContext.Provider value={{ collapsed, toggleCollapse }}>
      {children}
    </DocsSidebarContext.Provider>
  );
}

export function useDocsSidebar() {
  const context = useContext(DocsSidebarContext);
  if (!context) {
    throw new Error('useDocsSidebar must be used within DocsSidebarProvider');
  }
  return context;
}
